import React, {useContext} from "react";
import "./WhitePaper.scss";
import {whitepaperSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function WhitePaper() {
  const {isDark} = useContext(StyleContext);
  
if (whitepaperSection.display) {
    return (
        <div id="whitepaper">
            <Fade bottom duration={1000} distance="20px">
                <div className="whitepaper-container">
                    <div className="parallax-background">
                        <div className="whitepaper-overlay">
                            <h1 className={isDark ? "whitepaper-heading dark-mode" : "whitepaper-heading"}>
                                {whitepaperSection.title}
                            </h1>
                            <p className="whitepaper-subtitle">
                                {whitepaperSection.subtitle}
                            </p>
                            <a 
                                className="whitepaper-link" 
                                href={whitepaperSection.whitepaperUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {whitepaperSection.whitepaperUrl}
                            </a>
                        </div>
                    </div>
                </div>
            </Fade>
        </div>
    );
}
return null;
}
